import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Printer } from "lucide-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../utils/auth";
import { isOwner } from "../../utils/roles";
import ProductionAnalyticsSection from "./ProductionAnalyticsSection";

const ProductionAnalyticsPage = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();

  useEffect(() => {
    if (!authState.token && !authState.isValidating) {
      navigate("/login");
      return;
    }
    if (!authState.isValidating && !isOwner(authState.role)) {
      navigate("/dashboard");
    }
  }, [authState, navigate]);

  if (!isOwner(authState.role)) return null;

  return (
    <div
      dir="rtl"
      className="min-h-screen bg-gradient-to-br from-slate-100 via-indigo-50/40 to-slate-100 p-3 md:p-6"
    >
      <ToastContainer position="top-center" rtl autoClose={2500} />
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 md:p-2.5 rounded-xl bg-indigo-600 text-white shadow-sm">
              <Printer className="w-4 h-4 md:w-[22px] md:h-[22px]" />
            </div>
            <div>
              <h1 className="text-xl md:text-3xl font-bold text-slate-800">تحليل الإنتاج</h1>
              <p className="text-slate-500 text-sm mt-0.5">الباتشات المكتملة · القطع · سجل الإنتاج</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="p-2 rounded-xl bg-white border border-slate-200 hover:bg-slate-50 transition"
            title="لوحة التحكم"
          >
            <ChevronLeft size={26} />
          </button>
        </div>
        <ProductionAnalyticsSection />
      </div>
    </div>
  );
};

export default ProductionAnalyticsPage;
